import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { DashboardData } from "src/app/shared/models/dashboard.model";
import { Router } from "@angular/router";
import { DataElement } from "src/app/shared/models/common";
import { Store } from "@ngrx/store";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import {
  SELECT_SUPPLY_TYPE,
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
} from "src/app/shared/ngrx/ngrx-actions";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dash-supply-summary-lab",
  templateUrl: "./dash-supply-summary-lab.component.html",
  styleUrls: ["./dash-supply-summary-lab.component.scss"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class DashSupplySummaryLabComponent implements OnInit {
  routeEnum: RouteEnum = new RouteEnum();

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  constructor(private readonly store: Store, private router: Router) {}

  ngOnInit(): void {}

  filterOpenSupplyOrders(deliverySw: boolean, openSw: boolean) {
    this._dispatchSuppliesNavigation();

    this.router.navigate([this.routeEnum.URL_SUPPLIES], {
      queryParams: {
        status: openSw ? "OPEN" : "CLOSED",
        type: deliverySw ? "DELIVERY" : "OTHER",
        reuse: "false",
      },
    });
  }

  _dispatchSuppliesNavigation() {
    this.store.dispatch(
      UI__ROUTE_NAVIGATION({
        data: { link: this.routeEnum.URL_SUPPLIES },
      })
    );

    this.store.dispatch(
      UI__SIDEBAR_ROUTE_NAVIGATION({
        data: { tabId: "supplies" },
      })
    );
  }

  goToDeliveryOrder() {
    this.goToSuppliesOrder(true);
  }

  goToSuppliesOrder(selectDeliverySw: boolean = false) {
    this.store.dispatch(
      SELECT_SUPPLY_TYPE({
        type:
          selectDeliverySw == true ? new DataElement("DELIVERY") : undefined,
      })
    );

    this._dispatchSuppliesNavigation();
    this.router.navigate([this.routeEnum.URL_SUPPLIES]);
  }
}
